<template>
<div class="c-plan-form__fiber-options col-12 col-md-6 col-lg-5">
    <div
        class="custom-control custom-checkbox mb-4"
        v-for="(option, index) in planDataFromMagento.plan.custom_options.fixe.options"
        :key="index">
        <div class="d-flex justify-content-between">
            <input
                type="checkbox"
                class="custom-control-input"
                :id="'option-' + index"
                :value="option"
                :checked="checkStatus(option)"
                @change="updateOptionModel(option, option.value_identifier, $event.target.checked)">
            <label
                class="custom-control-label"
                :for="'option-' + index">{{ option.name }}</label>
            <span class="d-flex align-items-baseline">
            <h3>
                <strong class="text-primary">+{{ formatPrice(option.price) }}</strong>
            </h3>/{{$t('month')}}
        </span>
        </div>
        <div class="my-3">
            <span v-if="option.value_identifier === 'livebox_modem'" class="u-marg-t-xxs u-marg-b-xxs u-grey-text">
                {{ $t('Orange will provide a Livebox with Wi-Fi 6 to you so you can enjoy your Fiber connection.') }}
            </span>

            <div v-if="!isLiveboxModemChecked && option.value_identifier === 'livebox_modem'" class="col-12 alert alert-warning u-marg-t-sm" role="alert">
                <span class="alert-icon"><span class="sr-only">Warning</span></span>
                <div>
                    <h4 class="alert-heading">{{ $t('We recommend that you use Livebox for an optimal experience. You can use your own compatible equipment (e.g., Firtzbox). If it turns out not to be compatible during installation, our technician will provide a Livebox to you.') }}</h4>
                </div>
            </div>

            <span v-if="option.value_identifier === 'fixe'" class="u-marg-t-xxs u-marg-b-xxs u-grey-text">
                {{ $t('Unlimited calls to national landlines and mobiles + 5 hours in Europe') }}
            </span>

            <div v-if="landLineOptionModel && option.value_identifier === 'fixe'" class="my-3">
                <ValidationObserver ref="phoneNumberValidator" v-slot="{ invalid }">
                    <form @submit.prevent class="c-plan-form__phone-number-form">
                        <template>
                            <div
                                v-for="(option, index) in planDataFromMagento.plan.custom_options.portabilite.options"
                                :key="option.option_type_id"
                                class="custom-control custom-radio gtm-configurateur-phone-number u-marg-b-sm u-flex u-flex-align-center">
                                <input
                                    class="custom-control-input"
                                    type="radio"
                                    :name="`options[${option.option_id}]`"
                                    :id="'option-portability-' + index"
                                    :checked="checkedStatus(option)"
                                    :value="option.option_type_id"
                                    @change="onChange(option)">

                                <label class="custom-control-label u-middle" :for="'option-portability-' + index">
                                    <span>{{ option.name }}</span>
                                </label>

                            </div>
                        </template>

                        <keep-alive>
                            <div class="col-12 alert alert-success" role="alert" v-if="phoneNumber.phoneNumberChoice.sku === 'LandlinePortability'">
                                <span class="alert-icon"><span class="sr-only">Success</span></span>
                                <div>
                                    <h4 class="alert-heading"> {{ $t('One of our agents will contact you after your order in order to set up your number transfer.') }}</h4>
                                </div>
                            </div>
                        </keep-alive>
                    </form>
                </ValidationObserver>
            </div>
        </div>
    </div>

    <button
        @click="nextStep"
        type="button"
        id="next-step"
        class="btn btn-lg btn-primary px-lg-5">
        {{ planDataFromMagento.fiberInstallationStep ? $t('Next step') : $t('Add to basket') }}
    </button>
</div>

</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';

import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

import Helpers from '~plugins/Helpers';

import en from 'dayjs/locale/en';
import {mapActions} from "vuex";

export default {
    components: {
        flatPickr,
        ValidationProvider,
        ValidationObserver
    },
    props: {
        planDataFromMagento: {
            type: Object,
            default: () => null
        },
        traduction: {
            type: Function
        },
        dataFromCart: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        $t() {
            return this.traduction;
        },
    },
    watch: {
        landLineOptionModel: function (n,o) {
            if (n) {
                const currentState = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation')) || {}
                this.phoneNumber.phoneNumberChoice =
                    (currentState.landLineOption && typeof currentState.landLineOption === 'object' && Object.keys(currentState.landLineOption).length > 0)
                        ? this.planDataFromMagento.plan.custom_options.portabilite.options.find(
                        option => option.option_type_id === currentState.landLineOption.option_type_id
                    ) || this.planDataFromMagento.plan.custom_options.portabilite.options[0]
                        : this.planDataFromMagento.plan.custom_options.portabilite.options[0]
            } else {
                this.phoneNumber.phoneNumberChoice = {}
            }
        },
    },
    data() {
        return {
            formValidated: true,
            localData: {
                getNewPhoneNumber: 'Obtenir un nouveau numéro',
                keepPhoneNumber: 'Conserver mon numéro actuel',
                nextStep: 'Étape suivante'
            },
            phoneNumber: {
                phoneNumberChoice: {},
                keepPhoneNumber: {
                    keepPhoneNumber: true,
                }
            },
            errorMsg: '',
            optionModel: [],
            customOptionsModel: false,
            option: {},
            landLineOptionModel: false,
            landLineOption: {},
            isLiveboxModemChecked: true
        };
    },
    beforeMount() {
        const currentState = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation'));

        this.planDataFromMagento.plan.custom_options.fixe.options.forEach(e => {
            this.optionModel.push({[e.value_identifier]: {option: e, value: e.value_identifier, state: false}})
        })

        if (currentState && currentState.fiberOptions) {
            currentState.fiberOptions.length && currentState.fiberOptions.forEach((item, i) => {

                const key = Object.keys(item)[0];

                if (item[key].state === true){
                    this.optionModel.length && this.optionModel.forEach((item2, j) => {
                        const key2 = Object.keys(item2)[0];
                        if(key === key2){
                            this.optionModel[j][key2].state = true
                        }
                    })
                }
            });
            this.setOptionState({optionState: []})
            setTimeout(() => {
                this.setOptionState({optionState: this.optionModel})
            });
            this.checkCustomOptionsModel();
        }
    },
    methods: {
        ...mapActions({
            setOptionState: 'SET_OPTION_STATE'
        }),
        getOptionModel(option, value_identifier) {
            if (option.value_identifier === 'fixe') {
                return this.landLineOptionModel;
            } else {
                return this.optionModel.state;
            }
        },
        checkCustomOptionsModel(){
            this.customOptionsModel = false
            if (this.optionModel.length) {
                let hasTrueState = false;
                let onlyLiveboxModem = true;

                this.optionModel.forEach(item => {
                    const key = Object.keys(item)[0];
                    if (item[key].state === true) {
                        hasTrueState = true;
                        if (key !== "livebox_modem") {
                            onlyLiveboxModem = false;
                        }
                    }
                });

                this.customOptionsModel = hasTrueState && !onlyLiveboxModem;
            }
        },
        checkStatus(option) {
            let res = false;

            let currentState = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation'));
            if ((currentState === null || currentState.fiberOptions === undefined) && option.value_identifier === 'livebox_modem') {
                this.updateOptionModel(option, option.value_identifier, true)
                window.localStorage.setItem('mage-cache-storage-installation', JSON.stringify({fiberOptions: this.optionModel}));
            }

            this.optionModel.forEach(item => {
                const key = Object.keys(item)[0];

                if (key === 'fixe' && item[key].state === true) {
                    this.landLineOptionModel = true;
                }

                if (item[key].state === true && item[key].option.option_type_id === option.option_type_id) {
                    res = true;
                }
            });

            return res;
        },
        updateOptionModel(option, value, state) {
            const index = this.optionModel.findIndex(item => item.hasOwnProperty(value));

            if (index !== -1) {
                // Update the existing object
                this.optionModel[index] = {[value]: {option, value, state}};
            } else {
                // Add a new object
                this.optionModel = [...this.optionModel, {[value]: {option, value, state}}];
            }

            if (option.value_identifier === 'livebox_modem') {
                this.isLiveboxModemChecked = state;
            }

            if (option.value_identifier === 'fixe') {
                this.landLineOptionModel = state;
            }
            this.setOptionState({optionState: []})
            setTimeout(() => {
                this.setOptionState({optionState: this.optionModel})
            });
            this.checkCustomOptionsModel();
        },
        formatPrice(price) {
            if (isNaN(parseInt(price))) {
                return price
            }

            price = parseFloat(price);

            if (price % 1 === 0) {
                price = parseInt(price, 10);
            } else {
                price = price.toFixed(2);
            }

            const formattedPrice = this.planDataFromMagento.locale === 'en'
                ? price
                : price.toString().replace('.', ',');

            return this.planDataFromMagento.locale === 'en'
                ? `€${formattedPrice}`
                : `${formattedPrice}€`;
        },
        checkedStatus(option) {
            if(this.phoneNumber.phoneNumberChoice.option_type_id === option.option_type_id){
                this.landLineOption = option
            }
            return this.phoneNumber.phoneNumberChoice.option_type_id === option.option_type_id;
        },
        onChange(currentOption) {
            this.phoneNumber.phoneNumberChoice = currentOption;
            Helpers.pushDataLayer({
                'event': 'configurator_field',
                'step': 'phone_number_keep_current_number'
            });
        },
        async nextStep() {
            let currentState = JSON.parse(window.localStorage.getItem('mage-cache-storage-installation'));

            currentState = {
                ...currentState,
                fiberOptions: this.optionModel,
                landLineOption: this.landLineOption,
                landLineOptionModel: this.landLineOptionModel,
                customOptionsModel: this.customOptionsModel
            };

            window.localStorage.setItem('mage-cache-storage-installation', JSON.stringify(currentState));

            if(!!this.optionModel){
                document.cookie = "fiberOptions=" + JSON.stringify(this.optionModel) + "; expires=Fri, 27 Dec 2199 23:59:59 GMT; path=/"
            }

            if (!this.landLineOptionModel) {
                this.$emit('fiber-options-next-step', this.landLineOptionModel);
                return;
            }

            Helpers.pushDataLayer({
                'event': 'Configurator field',
                'click_name': 'Steps 2',
            })

            this.$emit('data-fiber-options-next-step', this.optionModel);
            this.$emit('data-phone-number-next-step', this.phoneNumber.phoneNumberChoice);
            this.$emit('fiber-options-next-step');
        }
    }
};
</script>
